<!--
  實例: 
  <hk-select v-model="select" :list="list"></hk-select>
  list: [{
    value: '', //選中時的值
    label: ''  //顯示的值
  }]
-->
<template>
  <div class="select">
    <!-- <div v-if="ifValue == ''"  class="select-btn" :class="active?'active':''"  @click="click" tabindex="0" @keydown="keydown" @blur="blur">
      {{selectShow || placeholder}}  -->
      <!-- {{ifValue}} -->
      <!-- <img src="@A/images/pullDown.png" class="select-icon"> -->
      <!-- <span class="select-icon glyphicon glyphicon-menu-down"></span>
    </div> -->

    <!-- <div v-if="ifValue != ''"  class="select-btn" :class="active?'active':''"  @click="click" tabindex="0" @keydown="keydown" @blur="blur" >
      {{ifValue || placeholder}}  -->
      <!-- {{ifValue}} -->
      <!-- <img src="@A/images/pullDown.png" class="select-icon"> -->
      <!-- <span class="select-icon glyphicon glyphicon-menu-down"></span>
    </div> -->

  <!-- <div   class="select-btn" :class="active?'active':''"  @click="click"  tabindex="0" @keydown="keydown" @blur="blur">
      {{selectShow || placeholder}} 
    <span class="select-icon glyphicon glyphicon-menu-down"></span>
  </div>
    
    <div class="select-list" v-show="active">
      <div style="display:block;" class="select-item" v-for="(item, index) in list" :key="index" :class="actNum==(index + 1) ? 'hover':''" @mousedown="select(item.value, item.label)">{{item.label}}</div>
    </div> -->
    <select @change="changeDropdownOption($event)" :class="ieCore ? 'selectIe' : 'selectDropDown'" :id="id" :aria-labelledby="ariaLabelledby">
      <option v-for="(item, index) in list" :key="index" :class="'dropDownClass'+name" @click="select(item.value, item.label)" :value="item.value" :id="item.value" :aria-describedby="ariaDescribedby">{{item.label}}</option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Select...',
    },
    
    list: {
      type: Array,
      default: []
    },
    ifValue:{
       type: String,
      default: '',
    },
    name: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    ariaDescribedby: {
      type: String,
      default: ''
    },
    ariaLabelledby: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      active: false,
      selectVal: '', // 已選擇的value
      selectShow: '', // 顯示的已選擇
      actNum: 0,
      ieCore: false,
    }
  },
  methods: {
    changeDropdownOption(e){
      //Added by Sam for OCGIO Accessibity Scan (21/07/2022)
      //Simulate Drop-down click implemented by ODC
      this.select(e.target.value,e.target.options[e.target.selectedIndex].innerHTML);
    },
    click () {
     //console.log( this.value)
    //  console.log(this.ifValue)
     this.$emit('clear',this.ifValue);
    
      this.active = !this.active
      this.actNum = 0
    },
    changeValue(val) {
    

      this.selectVal = val
      console.log(val);
      console.log(this.list)
      if(val == '') {
        var lang = this.sessionGetItem('Language');
        if (lang === '1') {
          this.selectShow = 'Select...'
        } else if (lang === '2') {
          this.selectShow = '選項'
        } else if (lang === '3') {
          this.selectShow = '选项'
        }
      }
      for(var i=0; i < this.list.length; i++){
        if (this.list[i].value == this.selectVal) {
          this.selectShow = this.list[i].label
        }
      }
    },
    keydown (e) {
      if (e.keyCode == 32 || e.keyCode == 13) {
        if(!this.actNum){
          this.click()
        }else{
          this.select(this.list[this.actNum-1].value, this.list[this.actNum-1].label)
        }
      }
      // 按下鍵
      if (e.keyCode == 40) {
        this.actNum++
        if(this.actNum > this.list.length){
          this.actNum = 1;
        }
      }
      // 按上鍵
      if (e.keyCode == 38) {
        this.actNum--
        if(this.actNum < 1){
          this.actNum = this.list.length
        }
      }

    },
    blur() {
      this.active = false
      this.actNum = 0
    },
    select (val, label) {
      if(this.value != val){
        this.actNum = 0
        this.selectVal = val
        this.selectShow = label
        this.active = false
        this.$emit('input', this.selectVal)
        this.$emit('change', this.selectVal)
      }else{
        this.active = false
      }
    }
  },
  mounted () {
    // console.log("this.selectShow##"+this.selectShow)
    // console.log("this.placeholder##"+this.placeholder)
    // console.log("this.value##"+this.value)
    console.log(this.name)
    this.ifValue = '';
    this.selectVal = this.value
    for(var i=0; i < this.list.length; i++){
      if (this.list[i].value == this.selectVal) {
        this.selectShow = this.list[i].label
      }
    }
    const dropDownClass = document.getElementsByClassName("dropDownClass"+this.name);
    for(let i=0;i<dropDownClass.length;i++){
      if(dropDownClass[i].id == this.value){
        dropDownClass[i].setAttribute("selected","")
      }
    }
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    if (userAgent.indexOf('Trident') !== -1 || userAgent.indexOf('MSIE') !== -1) { //表示使用的是IE的内核
      this.ieCore=true
    }
  },
  beforeUpdate () {
    console.log("11111")
    this.selectShow = ''
    this.selectVal = this.value
    for(var i=0; i < this.list.length; i++){
      if (this.list[i].value == this.selectVal) {
        this.selectShow = this.list[i].label
      }
    }
  }
  }
</script>

<style lang="scss" scoped>
// 樣式是HkSelect.scss, 在all.scss中引入
.selectDropDown {
  width: 150px;
  padding: 5px 35px 5px 5px;
  font-size: 16px;
  border: 1px solid #222;
  height: 34px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAABmJLR0QA/wD/AP+gvaeTAAADkklEQVR4nO3aTYiNURzH8e8Y42UaSV7ykihqCkWhJEWKzURmFiy8LIyFsjApWc1esiELK1YspISUFCkWarIgoShvYzSlJgzDuOZaPHNr3OZ6nvO/z8s50+9Tp2Zx55z/OT333uc+/x+IiIiIiIiIiIiIiIiIiIiIiMhEtBPoA8ox4wPQXlCNIWknOqu48/wI7GD0j7gXV0YJ6MxtK+HpJDqjpOfZC8mu/rFjBOjKaUMh6SI6G5ez7IXoLTPs+I9loDuXbYWhG/fzGwZ2VSZoA4YMk5wFGjLenM8agFO4n9svoKN6si3AN8Nk54FJ2ezPaw3AGdzP6zuwvdakm4AvhkkvA03p7s9rjcBF3M9pENgaN/la4LNh8hvAtHT257UpwFXcz2cA2JB0kRW43x2VgXtAS33781ozcBv3c+kHVrsu1kqyHxTV4wEw07Y/r7UAd3E/j0/AKuuiS4HXhkUfA3Oti3poFvAI93N4Cyyvd/EFwDPD4s+BRfUu7oH5wFPc9/8SWJxWEfOAJ4Yi3gDL0iqiAEuAV9guvoVpF2N9G/ZRx2dggVqB99g+fudkVVQL0Z2Oa1H9wJqsisrASmx3gQ/J4QakGbhjKG4A2Jh1cSlYh+130H1gRl5FTgWuGYocBLblVaTBZuAr7vu6BUzPu9gm4Iqh2J/42dhpA37gvp/rRBdkIRqBCzEFjjd+AwcKqLeWPdgeyV8CJhdQ7z+sTwVLwKEC6q22j+iCcK3fq6fADcBp3DcxAhwroN6KI8CfceqKG+fwtA9yAvfNlIGTqjU9x3HvjZbJr7tm7WKVCagNexjbWzvrz1Xr99UIcDTDujKxF9uXW1bdNWsXqwQczKCeXOzGdnt3k3S7a9YuVgnYn2IdhbAmLtLqrlm7WOMmF0JlTVzU212zdrH+m1wIlTVxYe2uWR+fJ0ouhMqauHiBW3fN2sVySi6Eypq4SNpds3axTMmFUFkTF3HdNWsXq67kQqisiYta3TVrFyuV5EKorImL6u7aemzfLakmF0JlTVxUumvWLlYmyYVQzQZ6cD/EIWw/8npG15QxrIkL15FLciFU1sRF0pFrciFU1sRF3CgkuRAqa+Ki1ig0uRAqa+KieniRXAiVtYNVGV4lF0JlTVx4m1wIlUuKwfvkQqiSJC6CSS6EqlbiIsjkQqiqExdBJxdC1UH07P8dE6h5LiIiIiIiIiIiIiIiIiIiIiIi4fsL122G7mJJLsAAAAAASUVORK5CYII=') 96% / 15% no-repeat #EEE;
}

.selectIe {
  width: 150px;
  font-size: 16px;
  border: 1px solid #222;
  height: 34px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
</style>



// WEBPACK FOOTER //
// src/components/cmsele.vue